import { useLocation } from "react-router-dom";

const ExploreOtherTopics = ({ type }: any) => {
  const { state } = useLocation();
  const { tag } = state;

  return (
    <div className="relative z-10 flex items-center justify-center h-screen bg-cover bg-center bg-no-repeat backdrop-blur-sm bg-black/60">
      {/* Content */}
      <div className="relative flex flex-col items-center text-center px-4">
        {/* Party Popper Emoji */}
        <div className="text-6xl mb-4">🎉</div>

        {/* Message */}
        <p className="text-white text-xl font-semibold leading-6">
          {type === "trending"
            ? "You’ve seen all your personalized trending news! Now, explore other topics."
            : type === "topicNews"
            ? `You’ve seen all feeds on ${tag?.code}. Now, explore other topics!`
            : type === "shotTags"
            ? `You’ve seen all feeds on ${tag?.tagName}. Now, explore other topics!`
            : "You’ve seen all feeds. Now, explore other topics!"}
        </p>
      </div>
    </div>
  );
};

export default ExploreOtherTopics;
